import type { TimeFormat } from '@lingoda/dates';
import { createDate, format } from '@lingoda/dates';
import { useField } from '@lingoda/forms';
import { trans } from '@lingoda/i18n';
import { getTimeFormat } from '@lingoda/students';
import { Typography } from '@lingoda/ui';

export const TimeInLocation = () => {
    const [timeFormat] = useField<TimeFormat>('timeFormat');
    const [timezone] = useField<string>('timezone');
    const time = format(getTimeFormat(timeFormat.value), createDate(undefined, timezone.value));

    return (
        <Typography variant="body1">
            {trans('time-in-your-location', { time }, 'student-common')}
        </Typography>
    );
};
